import * as React from 'react';
import './ListCalendar.scss';
import { prepareDateToString } from '../../utils/dateHelper';
import { enUS } from 'date-fns/locale';
import { format } from 'date-fns';
import { CalendarEventType, SpecialDay } from '../../types';
import { groupBy } from '../../utils/functions';
import { ReactComponent as EditIcon } from '@iba-team/portal-react-components/dist/svg/outline/edit.svg';
import { ReactComponent as DeleteIcon } from '@iba-team/portal-react-components/dist/svg/outline/trash.svg';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@iba-team/portal-react-components/dist';
import { checkPastDate } from './FullCalendar';
import { contramap } from 'fp-ts/Ord';
import { Ord } from 'fp-ts/Date';
import { pipe } from 'fp-ts/function';
import { sort } from 'fp-ts/ReadonlyArray';
import { BREAKPOINT_LG } from '../../consts';
import { deleteEventModalCall, editEventModalCall } from './CalendarPage';
import { observer } from 'mobx-react';
import { useCheckAccess, useDeviceSizeThreshold } from '../../utils/hooks';

type SourceType = {
  dayType: CalendarEventType
  description: string
  endDate: Date
  startDate: Date,
  titleMonth: number
  title: string,
  id: number,
  isWeekend?: boolean,
}

type List = {
  dataSource: ReadonlyArray<SpecialDay>,
  setDataSource: (data: SpecialDay[])=> void,
}

export const ListCalendar = observer((props:List) => {
  const {t} = useTranslation();
  const isOneDayEvt = (evt: SpecialDay) => evt.endDate === evt.startDate || !evt.endDate;
  const prepareStartDate = (evt: SpecialDay) => prepareDateToString(enUS)(new Date(evt.startDate));
  const prepareEndDate = (evt: SpecialDay) => prepareDateToString(enUS)(new Date(evt.endDate));
  const source : ReadonlyArray<SourceType> = props.dataSource.map(item=>({...item,titleMonth: new Date(item.startDate).getMonth() + 1}));
  const isTablet = useDeviceSizeThreshold(BREAKPOINT_LG);
  const {isAllowedAccess} = useCheckAccess('CALENDAR_ADMIN');
  const byDate = pipe(
    Ord,
    contramap((date: SourceType) => date.startDate)
  );
  return (
    <div className={'listCalendarPage'}>
      {Object.entries(groupBy<ReadonlyArray<SourceType>, string>(source, 'titleMonth')).map(([key, arr], index) =>
        <div key={index} className={'list'}>
          <h3 className={'listTitle'}>
            {format(new Date(arr[0].startDate), 'LLLL')}
          </h3>
          <div className={'listData'}>
            {sort(byDate)(arr).map((m,index) =>
              <div key={index} className={'listItem'}>
                <div className={'listItemContent'}>
                  <div className={'listItemLeft'}>
                    <span className={'dayNumber'}>
                      {prepareStartDate(m)('d')}
                      {!isOneDayEvt(m) &&
                        <span>-{prepareEndDate(m)('d')}</span>
                      }
                    </span>
                    <span className={'monthText'}>
                      {prepareStartDate(m)('MMM')}
                    </span>
                    <div className={'dayText'}>
                      ({prepareStartDate(m)('EEEE')}
                      {!isOneDayEvt(m) &&
                        <div className={'dayTextEnd'}>
                          <span>-</span>
                          <span>{prepareEndDate(m)('EEEE')}</span>
                        </div>
                      })
                    </div>
                  </div>
                  <div className={'listItemRight'}>
                    {m.title}
                  </div>
                </div>
                {!isTablet && isAllowedAccess && !checkPastDate(new Date(m.startDate)) &&
                  <div className={'listItemRedactPanel'}>
                    <Tooltip title={t('edit')}>
                      <div
                        className={'ticket_footer__edit'}
                        onClick={() => editEventModalCall.showImmediately({
                          specialDays: {
                            dayType: m.dayType,
                            description: m.description,
                            endDate: new Date(m.startDate),
                            startDate: new Date(m.startDate),
                            title: m.title,
                            id: m.id,
                            isWeekend: m.isWeekend,
                          },
                          setDataSource: props.setDataSource,
                          dataSource: props.dataSource,
                        }) }>
                        <EditIcon/>
                      </div>
                    </Tooltip>
                    <Tooltip title={t('delete')}>
                      <div
                        className={'ticket_footer__delete'}
                        onClick={() => deleteEventModalCall.showImmediately({
                          specialDays:{
                            id: m.id, title: m.title,dayType: m.dayType
                          },
                          setDataSource:  props.setDataSource,
                          dataSource: props.dataSource
                        }) } >
                        <DeleteIcon/>
                      </div>
                    </Tooltip>
                  </div>
                }
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
});
